import { initSnacks } from '@dolnpm/redux-snack-messages'
initSnacks('info-snack-data', 'flash-messages')